



















































































































import Vue from 'vue';
import Modal from '../components/common/Modal/Modal.vue';
import ErrorLabelDataInformationView from './LabelData/ErrorLabelDataInformationView.vue';
import UpdateLabelDataView from './LabelData/UpdateLabelDataView.vue';
import { getLabelDataPaths } from '@/utils/axiosInstances';
import { showUnsupportedMessage } from '@/utils/demoUtils';

interface errorList {
  property: string;
  keyword: string;
  schema: string;
  givenData: string;
}
interface labelData {
  name: string;
  errorTypeList: string[];
  errorList: errorList[];
}

export default Vue.extend({
  props: ['flag', 'dataList', 'page'],
  components: {
    Modal,
    ErrorLabelDataInformationView,
    UpdateLabelDataView,
  },
  data(): {
    tableHeaders: string[];
    checkedLabelData: string[];
    color: string[];
    buttonFlag: boolean;
    informationFlag: boolean;
    error: labelData;
    updateDataFlag: boolean;
  } {
    return {
      tableHeaders: ['번호', '이름', '에러'],
      checkedLabelData: [],
      color: ['#FC5E54', '#FF974D', '#24BE99', '#FBB500'],
      buttonFlag: false,
      informationFlag: false,
      error: {
        name: '',
        errorTypeList: [],
        errorList: [],
      },
      updateDataFlag: false,
    };
  },
  watch: {
    dataList: {
      handler: async function () {
        if (!this.flag || !this.dataList.length) return;

        this.$store.commit('startLoading');
        const labelIdList = this.dataList.map((d: { name: string }) => d.name);

        const labelWithPathsDict = await getLabelDataPaths(
          this.$route.params.labelsetId,
          labelIdList,
        );

        for (let i = 0; i < this.dataList.length; i++) {
          const labelDataPath = labelWithPathsDict[this.dataList[i].name];
          if (!labelDataPath || labelDataPath === '.') {
            this.dataList[i].path = this.dataList[i].name;
            continue;
          }

          this.dataList[i].path = `${labelDataPath}`;
          this.$forceUpdate();
          this.$store.commit('stopLoading');
        }
      },
      immediate: true,
    },
    checkedLabelData: function (checkedLabelData) {
      if (checkedLabelData.length > 0) this.buttonFlag = true;
      else this.buttonFlag = false;
    },
    // label data 수정페이지를 닫은 경우 갱신된 데이터를 받아오기위한 새로고침
    updateDataFlag: function (updateDataFlag) {
      if (updateDataFlag === false) {
        showUnsupportedMessage(this.$toast);
        // window.location.reload();
      }
    },
  },
  methods: {
    allCheckData() {
      this.checkedLabelData = [];
      for (let data of this.dataList) {
        this.checkedLabelData.push(data.name);
      }
    },
    showErrorModal(data: labelData) {
      this.error = JSON.parse(JSON.stringify(data));
      this.informationFlag = true;
    },
  },
});
